import React from 'react'
import campus from "../../assets/images/resource/project-10.jpg" ;
import office from '../../assets/images/background/office.jpg';
import photo from "../../assets/images/president.png";
import mekanisa2 from '../../assets/images/icons/mekanisa2.jpg';
import Dean from '../../assets/images/icons/teklay.jpg'
import MekeleStudent from  '../../assets/images/icons/mekelestudent.jpg'
import UnderlineWithIcon from '../components/UnderlineWithIcon';
const AcademicPresidentOffice = () => {
 return (
  <div>          
    <div className="banner-slide">
      <img src={office} alt="Banner 2" className="banner-image" />
      <div className="banner-content">
        <h2>OFFICE OF THE ACADEMIC VICE PRESIDENT – PROMOTING ACADEMIC EXCELLENCE</h2>
      </div>
    </div>

    <section className="projects-details">
      <h3 style={{ textAlign: 'center', marginBottom: '30px' }}>OFFICE OF THE ACADEMIC VICE PRESIDENT</h3>
		<UnderlineWithIcon/>
      <div className="auto-container">
        <div className="text-block">
          <div className="row">
            <div className="col-lg-10">
              <h4></h4>
              <div className="text">
                <p>
                  Dear Members of the Admas University Community, welcome to the Office of the Academic Vice President! 
                  We are dedicated to fostering a vibrant academic environment through innovative leadership, program development, and student engagement. 
                  Our commitment to academic excellence ensures the highest standards in educational practices and curriculum development.
                  
                  As we navigate the evolving landscape of higher education, I invite you to explore our initiatives and join us in our mission to empower students and enhance our academic community.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-block">
          <div className="row">
            <div className="col-lg-6">
              <div className="sec-title style-two">
                <h4>MEET THE ACADEMIC VICE PRESIDENT</h4>
              </div>
              <div>
                <p>
                  Short biography highlighting the Academic Vice President’s background, academic qualifications, and leadership experience. Mention any significant achievements and contributions to the university and community.
                </p>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="image"><img src={photo} alt="" /></div>
              <p className='designation'>Molla Tsegay (PhD)</p>
            </div>
          </div>
        </div>

        <hr />
        <div className="text-block-two">
          <div className="row">
            <div className="col-lg-12">
              <h4>STRATEGIC INITIATIVES</h4>
              <div className="text">
                The Office of the Academic Vice President is dedicated to several key initiatives that enhance our academic impact:
              </div>
              <ul className="services-list">
                <li><div className="icon-box"><span className="flaticon-book"></span> Academic Programs: Development of innovative programs that align with industry needs and student interests.</div></li>
                <li><div className="icon-box"><span className="flaticon-book"></span> Research Initiatives: Promoting research that addresses local and global challenges.</div></li>
                <li><div className="icon-box"><span className="flaticon-book"></span> Student Engagement: Enhancing student participation in academic and community activities.</div></li>
              </ul>
            </div>
          </div>
        </div>

        <hr />
        <div className="text-block-two">
          <div className="row">
            <div className="col-lg-10">
              <h4>ACCOMPLISHMENTS AND MILESTONES</h4>
              <div className="text">
                Under the leadership of the Academic Vice President, Admas University has achieved:
                <ul className="services-list">
                  <li><div className="icon-box"><span className="flaticon-book"></span> Launching [specific academic programs or initiatives].</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span> Receiving [academic awards or recognitions].</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span> Establishing partnerships with [academic institutions].</div></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div className="text-block-two">
          <div className="row">
            <div className="col-lg-10">
              <h4>COMMUNITY ENGAGEMENT</h4>
              <div className="text">
                The Office of the Academic Vice President believes in the power of community. Our initiatives include:
                <ul className="services-list">
                  <li><div className="icon-box"><span className="flaticon-book"></span> Academic Forums: Regular sessions where students and faculty can share knowledge and ideas.</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span> Service Learning Projects: Collaborating with local organizations to enhance learning through community service.</div></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div className="text-block-two">
          <div className="row">
            <div className="col-lg-10">
              <h4>POLICIES AND GOVERNANCE</h4>
              <div className="text">
                The Office of the Academic Vice President is committed to transparent governance. Here, you can find information about:
                <ul className="services-list">
                  <li><div className="icon-box"><span className="flaticon-book"></span> Academic Policies: Access to important documents and guidelines that shape our academic environment.</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span> Governance Structure: An overview of how academic decisions are made within the university.</div></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div className="text-block-two">
          <div className="row">
            <div className="col-lg-10">
              <h4>CONTACT US</h4>
              <div className="text">
                For more information or inquiries, please reach out to the Office of the Academic Vice President: 
                Email: [mollat@admasuniversity.edu.et]
                Phone: [+251 123 456 789]
                Office Location: OLYMPIA, 801, Admas University
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);
}

export default AcademicPresidentOffice